import { errorHandlerReport } from "@mgdx-libs/error-handler";
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

import { CURRENT_PATIENT_QUERY_OPTIONS } from "./constants/queryOptions";
import { patientKeys } from "./factories/patient";

export const createQueryClient = () => {
  const client = new QueryClient({
    queryCache: new QueryCache({
      onError: (error) => {
        errorHandlerReport(error);
      },
    }),
    mutationCache: new MutationCache({
      onError: (error) => {
        errorHandlerReport(error);
      },
    }),
  });

  // 患者情報は複数の hook が同じ key で購読するため、どの hook から購読しても再取得の挙動を揃える
  client.setQueryDefaults(patientKeys.patient.current.queryKey, CURRENT_PATIENT_QUERY_OPTIONS);

  return client;
};

export const queryClient = createQueryClient();

/**
 * 認証主体が変わるときに、前の患者の取得結果と取得中のリクエストを破棄する。
 */
export const clearServerState = () => {
  // clear() は表示中の画面へ通知しないため、先に初期状態へ戻して画面からも前の患者の取得結果を消す
  queryClient
    .getQueryCache()
    .getAll()
    .forEach((query) => query.reset());
  queryClient.clear();
};

/**
 * 取得結果を初期状態に戻し、表示中の query を取り直す。
 */
export const resetServerState = () => {
  void queryClient.resetQueries();
};
